import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';

import { Spacer } from '@components/1-atoms';
import Text from '@components/1-atoms/Text';
import ListItem from '@components/2-molecules/ListItem';

import Down from '@assets/icons/down';

import useTheme from '@lib/theme';

const theme = useTheme();

const styles = StyleSheet.create({
    container: {
        width: '100%',
        overflow: 'hidden',
        backgroundColor: 'transparent',

        // borderBottomWidth: 1,
        // borderBottomColor: '#ddd',
    },

    content: {
        overflow: 'hidden',
        // paddingBottom: 24,
    },
    rotatedIcon: {
        transform: [{ rotate: '180deg' }],
    },
});

export type Props = {
    title: string;
    children?: React.ReactNode | string;
    isExpanded?: boolean;
}

export const AccordionItem: React.FC<Props> = ({ title, children, isExpanded = false, ...props }) => {

    const [expanded, setExpanded] = useState(isExpanded);
    const toggleExpand = () => setExpanded(!expanded);

    return (
        <View style={styles.container}>

            <ListItem inset onPress={toggleExpand} right={<Down style={expanded ? styles.rotatedIcon : {}} />}>
                <Text bold color={theme.pallete.accentColor}>{title}</Text>
            </ListItem>

            {expanded && (<View style={styles.content}><Spacer />{children}</View>)}

        </View>
    );
};

export default AccordionItem;